import axios from 'axios';
import { customiseBundlesURL, orderSummaryURL } from './Constants';
import { usePrequalCookie, useLocalStorage } from './EirPrequalPersistance.js';

export async function createOrder(bundleOfferId) {
    try{
        const { getLocalStorage } = useLocalStorage();
        const { setCookie } = usePrequalCookie();
        let prequalId = getLocalStorage('eir_prequal_data').prequalId;
        let globalCustomerType = getLocalStorage('global_customer_type');
        if(prequalId && globalCustomerType && bundleOfferId && (typeof bundleOfferId)=="string"){
            const response = await axios({
                method: 'post',
                url: `/store/api/orders/create/${bundleOfferId}/${prequalId}?customerType=${globalCustomerType}`,
            });
            if(response.data.order.id && response.status == 200){
                setCookie('eir_current_order',response.data.order.id);
                //When adding NBI skip customise page and go to summary page
                if(bundleOfferId.includes('NBI')){
                    window.location.href = orderSummaryURL;
                }
                else{
                    window.location.href = customiseBundlesURL;
                }

            }
        }
        else
        { 
            throw new Error("required information missing");
        }
    }
    catch(error){
        console.error("something went wrong while creating order",error);
        return error;
    }
};